import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import GoogleBrandIcon from './GoogleBrandIcon';
import { startGoogleFlow } from '../utils/googleAuth';
export default function GoogleAuthButton({ purpose = 'login', returnTo = '/apps', onError, disabled = false }) {
  const [busy, setBusy] = useState(false);
  async function start() {
    setBusy(true);
    onError?.('');
    try { await startGoogleFlow({ purpose, returnTo }); }
    catch (error) { onError?.(error.response?.data?.message || error.message || 'No se pudo continuar con Google.'); setBusy(false); }
  }
  return <Button fullWidth type="button" variant="outlined" size="large" disabled={disabled || busy} onClick={start}
    startIcon={busy ? <CircularProgress size={18} /> : <GoogleBrandIcon size={20} />} sx={{ py: 1.5, borderRadius: 2 }}>
    {purpose === 'link' ? 'Vincular Google' : 'Continuar con Google'}
  </Button>;
}
